import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { SwitchTabs } from '@pepper/ui'

import TopicsFilter from 'container/Projects/LiveProjects/Project/IdeaLab/Topics/Filter'
import KeywordsFilter from 'container/Projects/LiveProjects/Project/IdeaLab/Keywords/Filter'

import s from './Switch.module.css'

export const Switch = () => {
  const [queryParams, setQueryParams] = useQueryParams({
    step: withDefault(StringParam, undefined),
    sug_page: withDefault(NumberParam, 1),
    sug_limit: withDefault(NumberParam, 15),
    sort: withDefault(StringParam, undefined),
  })

  return (
    <div className={s.header}>
      <div className={s.switchWrapper} data-id="topic-keyword-switcher">
        <SwitchTabs
          activeTab={
            queryParams.step === 'topic_suggestions' ? 'topics' : 'keywords'
          }
          onTabChange={tab => {
            const updatedStep =
              tab === 'topics' ? 'topic_suggestions' : 'keyword_suggestions'
            setQueryParams(
              {
                step: updatedStep,
                sug_limit: undefined,
                sug_page: undefined,
                sort: undefined,
              },
              'replaceIn'
            )
          }}
          tabList={[
            {
              title: 'Topics',
              value: 'topics',
            },
            {
              title: 'Keywords',
              value: 'keywords',
            },
          ]}
        />
      </div>
      {queryParams.step === 'topic_suggestions' && (
        <TopicsFilter isSuggested={true} />
      )}
      {queryParams.step === 'keyword_suggestions' && (
        <KeywordsFilter isSuggested={true} />
      )}
    </div>
  )
}
